<div class="smart-cart-form-display-conditions">
  <div class="section">
    <pdq-heading element="h5">Display Conditions</pdq-heading>
    <div class="controls-wrapper">
      <span>This widget will only appear if:</span>
      <pdq-rules-dynamic-form
        [formGroup]="formGroup"
        formArrayFieldName="rules"
        [rules]="displayRules | addCurrencyOption: shopCurrencySymbol"
        [entities]="displayRulesEntities"
        [shopCurrencySymbol]="shopCurrencySymbol"
        [versionWithOrOperator]="true"></pdq-rules-dynamic-form>
      <span class="customer-conditions-hint">
        Customer conditions (customer tags, order count, spend) only match shoppers who are logged in to their account.
        For guests these rules always evaluate as not met.
      </span>
    </div>
  </div>
</div>
